// Задание (К-07) и результат (К-08) в родительском режиме.
import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { StarIcon } from "@brovka/ui";
import { TopBar } from "../components/Shell.tsx";
import { findScenario } from "../lib/content/catalog.ts";
import { QuizView, type QuizResult } from "../quiz/QuizView.tsx";
import { activeChild, useApp } from "../state/app.ts";
import { t } from "../i18n/ru.ts";

export function QuizScreen() {
  const { id = "", quizId = "" } = useParams();
  const nav = useNavigate();
  const content = useApp((s) => s.content);
  const ref = content ? findScenario(content, id) : undefined;
  const [variant, setVariant] = useState<"original" | "mirror">("original");
  const [result, setResult] = useState<QuizResult | null>(null);
  const [round, setRound] = useState(0);
  const child = activeChild();
  if (!content || !ref) return <p className="page">{t.player.notFound}</p>;
  const s = ref.scenario;
  const quizzes = s.scenario.quizzes ?? [];
  const idx = quizzes.findIndex((q) => q.id === quizId);
  const nextQuiz = quizzes[idx + 1];
  const stage = child?.stage ?? s.scenario.ageStages[0] ?? "A";
  return (
    <div className="page">
      <TopBar title={s.scenario.title} back={() => nav(`/scenario/${encodeURIComponent(id)}`)} />
      {result ? (
        <section className="result" aria-live="polite">
          <div className="result__stars">
            <StarIcon size={64} filled={result.firstGrade !== "bad"} />
            <StarIcon size={64} filled={result.firstGrade === "great"} />
          </div>
          <h2>{result.grade === "great" ? t.quiz.great : result.grade === "ok" ? t.quiz.ok : t.quiz.bad}</h2>
          <div className="stack">
            {s.scenario.mirrorAllowed ? (
              <button
                className="btn btn--primary"
                onClick={() => {
                  setVariant(variant === "original" ? "mirror" : "original");
                  setResult(null);
                  setRound(round + 1);
                }}
              >
                {t.quiz.again}
              </button>
            ) : null}
            {nextQuiz ? (
              <button className="btn" onClick={() => (setResult(null), nav(`/scenario/${encodeURIComponent(id)}/quiz/${nextQuiz.id}`))}>
                {t.common.next}
              </button>
            ) : null}
            <button className="btn" onClick={() => nav(`/scenario/${encodeURIComponent(id)}`)}>
              {t.quiz.toPlayer}
            </button>
          </div>
        </section>
      ) : (
        <QuizView key={`${quizId}-${variant}-${round}`} compiled={s} quizId={quizId} variant={variant} stage={stage} kid={false} content={content} childId={child?.id} onDone={setResult} />
      )}
    </div>
  );
}
